var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-guide"},[_c('block-shelf-resources',{attrs:{"viewing-id":_vm.profile.userId,"apps":_vm.myApps,"display-app-icons":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }